var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcArrowLeftGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.4654 6.88737V3.43648C29.4654 3.13737 29.1216 2.97219 28.8895 3.15523L8.7645 18.874C8.59351 19.007 8.45515 19.1772 8.35998 19.3718C8.26481 19.5664 8.21533 19.7801 8.21533 19.9967C8.21533 20.2134 8.26481 20.4271 8.35998 20.6217C8.45515 20.8163 8.59351 20.9865 8.7645 21.1195L28.8895 36.8383C29.1261 37.0213 29.4654 36.8561 29.4654 36.557V33.1061C29.4654 32.8874 29.3627 32.6776 29.1931 32.5436L13.1216 19.999L29.1931 7.44987C29.3627 7.31594 29.4654 7.10612 29.4654 6.88737Z",
    fill: "#989BA0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowLeftGrey);
export default __webpack_public_path__ + "static/media/ic_arrow_left_grey.ea677b0c997c74391803b9dbedcdbc88.svg";
export { ForwardRef as ReactComponent };